import { generatePath, Redirect, Route, Switch } from 'react-router-dom';

import { paths, PatientRoutePrefix, Routes } from 'routes';

import { Role } from 'features/auth/types';

import { Skeleton } from 'antd';
import { useAppSelector } from 'lib/store/rootReducer';
import { PrivateRoute } from 'navigation/router/components/routes/private-route';
import { PatientRouteSwitchPatientId } from './route-switch-patient-patientid/route-switch-patient-patientid';
import { PatientRoutePattern } from './utils/patient-route-helpers';

export function PatientRouteSwitch() {
  const { user, isUserDataLoading: userIsLoading } = useAppSelector(
    state => state.auth
  );

  const isPatient = user?.role === Role.Patient;
  if (userIsLoading) return <Skeleton active />;

  return (
    <Switch>
      <PrivateRoute
        roles={[Role.Clinician, Role.ClinicAdmin, Role.Patient]}
        path={PatientRoutePattern}
        component={() => <PatientRouteSwitchPatientId user={user!} />}
        redirectPath={PatientRoutePrefix}
      />

      <Route
        /**
         * Catch all routes that were not matched
         */
        path={[PatientRoutePrefix]}
        render={() => {
          // Redirect to the sign-in page if the user is not logged in
          if (!user) {
            return <Redirect to={paths.signIn()} />;
          }

          // If the user is logged in and is a patient then redirect them to the `patient/<patientId>` route
          if (isPatient)
            return (
              <Redirect
                to={generatePath(PatientRoutePattern, { patientId: user.uid })}
              />
            );

          // Otherwise the user is a clinician
          return <Redirect to={Routes.ClinicianHome} />;
        }}
      />
    </Switch>
  );
}
